module.exports = __webpack_public_path__ + "static/media/roboto3.ef7c6637.woff2";